import { Directive, ElementRef, HostListener, Renderer2, Input } from "@angular/core";

@Directive({
  selector: "[appFloatFormat]",
})
export class FloatFormatDirective {
  @Input() maxValue?: number; // Giá trị tối đa có thể nhập

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener("input", ["$event"]) onInputChange(event: Event) {
    let value = this.el.nativeElement.value;
  
    // Chỉ giữ lại số và dấu "."
    value = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
  
    // Kiểm tra số chữ số thập phân (tối đa 4)
    const parts = value.split(".");
    if (parts.length > 2) {
      value = parts[0] + "." + parts.slice(1).join(".").substring(0, 4);
    } else if (parts.length === 2 && parts[1].length > 4) {
      value = parts[0] + "." + parts[1].substring(0, 4);
    }
  
    if (value === ".") value = "0.";
  
    let numValue = parseFloat(value);
    if (!isNaN(numValue) && this.maxValue !== undefined && numValue > this.maxValue) {
      numValue = this.maxValue;
    }
  
    if (!isNaN(numValue)) {
      const integerPart = Math.floor(numValue).toLocaleString("en-US");
      const decimalPart = parts.length === 2 ? "." + parts[1] : "";
      value = integerPart + decimalPart;
    }
  
    this.renderer.setProperty(this.el.nativeElement, "value", value);
    this.el.nativeElement.dispatchEvent(new Event("input", { bubbles: true }));
  }
  
  @HostListener("blur") onBlur() {
    let value = this.el.nativeElement.value.replace(/,/g, "");
    let numValue = parseFloat(value);
  
    if (isNaN(numValue) || numValue <= 0) {
      numValue = 0;
    } else if (this.maxValue !== undefined && numValue > this.maxValue) {
      numValue = this.maxValue;
    }
  
    const formattedValue = numValue.toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 4 // Cho phép tối đa 4 chữ số thập phân
    });
  
    this.renderer.setProperty(this.el.nativeElement, "value", formattedValue);
    this.el.nativeElement.dispatchEvent(new Event("input", { bubbles: true }));
  }
}
